import type { TourDefinition } from '../types';
import { TOUR_IDS } from '../types';

export const walletTour: TourDefinition = {
  id: TOUR_IDS.WALLET,
  steps: [
    {
      target: '[data-tour="wallet-header"]',
      titleKey: 'wallet.welcome.title',
      contentKey: 'wallet.welcome.content',
      placement: 'bottom',
      skipBeacon: true,
    },
    {
      target: '[data-tour="wallet-balance"]',
      titleKey: 'wallet.balance.title',
      contentKey: 'wallet.balance.content',
      placement: 'top',
    },
    {
      target: '[data-tour="wallet-buy-usdt"]',
      titleKey: 'wallet.buyUsdt.title',
      contentKey: 'wallet.buyUsdt.content',
      placement: 'top',
    },
    {
      target: '[data-tour="wallet-buy-ec"]',
      titleKey: 'wallet.buyEc.title',
      contentKey: 'wallet.buyEc.content',
      placement: 'top',
    },
    {
      target: '[data-tour="wallet-claim-ec"]',
      titleKey: 'wallet.claimEc.title',
      contentKey: 'wallet.claimEc.content',
      placement: 'top',
    },
    {
      target: '[data-tour="wallet-cash-out"]',
      titleKey: 'wallet.cashOut.title',
      contentKey: 'wallet.cashOut.content',
      placement: 'top',
    },
    {
      target: '[data-tour="wallet-transactions"]',
      titleKey: 'wallet.transactions.title',
      contentKey: 'wallet.transactions.content',
      placement: 'top',
    },
  ],
};
